// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HL3d","title":"styles_title__3xY60"};